import { useRoles } from "./RolePicker";

export const SkillChips = ({ prefix, department, value, onChange, label = "Skills", hint }) => {
  const departments = useRoles();
  const skills = departments.find((d) => d.value === department)?.skills || [];
  const toggle = (s) => onChange(value.includes(s) ? value.filter((x) => x !== s) : [...value, s]);
  return (
    <div className="md:col-span-2" data-testid={`${prefix}-skills`}>
      <p className="mb-3 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-400">
        {label} {hint && <span className="normal-case tracking-normal text-slate-500">({hint})</span>}
      </p>
      {!department && <p className="text-sm text-slate-500">Select a department to see skills.</p>}
      <div className="flex flex-wrap gap-2">
        {skills.map((s) => {
          const on = value.includes(s);
          return (
            <button type="button" key={s} onClick={() => toggle(s)} aria-pressed={on}
              data-testid={`${prefix}-skill-${s.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className={`border px-3 py-1.5 text-sm transition-colors ${on ? "border-orange-500 bg-orange-500/15 text-orange-200" : "border-white/10 text-slate-300 hover:border-orange-500/60"}`}>
              {s}
            </button>
          );
        })}
      </div>
    </div>
  );
};
